import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LogoInfo } from 'src/app/models/logo-info';
import { LogosService } from 'src/app/services/logos.service';
import { FormsModule } from '@angular/forms';
import { NgFor } from '@angular/common';

@Component({
    selector: 'app-logos-manager',
    templateUrl: './logos-manager.component.html',
    styleUrl: './logos-manager.component.scss',
    imports: [FormsModule, NgFor]
})
export class LogosManagerComponent implements OnInit {
  logos: LogoInfo[] = [];
  addName = '';
  addFile: File | null = null;
  uploading = false;
  logosBaseUrl: string;

  constructor(
    public activeModal: NgbActiveModal,
    private logosService: LogosService
  ) {
    this.logosBaseUrl = this.logosService['baseUrl'];
  }

  ngOnInit() {
    this.loadLogos();
  }

  loadLogos() {
    this.logosService.getLogos().subscribe(data => {
      this.logos = data;
    });
  }

  onAddFileSelected(event: any) {
    this.addFile = event.target.files[0] || null;
  }

  addLogo() {
    if (!this.addName || !this.addFile) return;
    this.uploading = true;
    this.logosService.addLogo(this.addName, this.addFile).subscribe({
      next: () => {
        this.addName = '';
        this.addFile = null;
        this.loadLogos();
      },
      error: err => {
        if (err.status === 409) {
          alert('Logo already exists.');
        } else {
          alert('Failed to add logo');
        }
      },
      complete: () => this.uploading = false
    });
  }

  updateLogo(logo: LogoInfo, event: any) {
    const file: File = event.target.files[0];
    if (!file) return;
    this.uploading = true;
    this.logosService.updateLogo(logo.name, file).subscribe({
      next: () => this.loadLogos(),
      error: err => {
        if (err.status === 404) {
          alert('Logo not found.');
        } else {
          alert('Failed to update logo');
        }
      },
      complete: () => this.uploading = false
    });
  }

  deleteLogo(logo: LogoInfo) {
    if (!confirm(`Delete logo "${logo.name}"?`)) return;
    this.logosService.removeLogo(logo.name).subscribe({
      next: () => this.loadLogos(),
      error: () => alert('Failed to delete logo')
    });
  }

  cancel() {
    this.activeModal.dismiss();
  }
}